import { parseTime } from "@/utils/ruoyi";
import { i18n } from "@/main.js";

// 云服务器管理
export const cloudServerHeader = () => [
  {
    key: "id",
    label: i18n.t("实例ID"),
    class: "text-center",
    formatter: (value) => {
      return value || "--";
    },
  },
  {
    key: "productName",
    label: i18n.t("产品名称"),
    class: "text-center",
    formatter: (value) => {
      return value || "--";
    },
  },
  {
    key: "status",
    label: i18n.t("实例状态"),
    class: "text-center",
    formatter: (value) => {
      // 定义状态映射关系
      const statusMap = {
        1: i18n.t("运行中"),
        2: i18n.t("已停止"),
        3: i18n.t("已过期"),
        4: i18n.t("创建中"),
      };

      return statusMap[value] || value || "--";
    },
  },
  {
    key: "sku",
    label: i18n.t("规格"),
    class: "text-center",
    formatter: (value) => {
      if (Array.isArray(value) && value.length > 0) {
        return value[0].name || "-";
      }
      return "-";
    },
  },
  {
    key: "expiration",
    label: i18n.t("倒计时长"),
    class: "text-center",
    formatter: (value, key, item) => {
      const endDate = new Date(item.expirationDate);
      const currentDate = new Date();

      // 检查到期时间是否有效
      if (!endDate || isNaN(endDate.getTime())) {
        return "--";
      }

      // 计算时间戳差值（单位为毫秒）
      const timeDiff = endDate.getTime() - currentDate.getTime();

      // 如果到期时间小于等于当前时间，表示已过期
      if (timeDiff <= 0) {
        return "--";
      }

      // 计算剩余天数
      const remainingDays = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

      return `${remainingDays}天`;
    },
  },
  {
    key: "payTime",
    label: i18n.t("支付时间(UTC-8)"),
    class: "text-center",
    formatter: (value) => {
      return value ? parseTime(value) : "--";
    },
  },
  {
    key: "expirationDate",
    label: i18n.t("结束时间"),
    class: "text-center",
    formatter: (value) => {
      return value ? parseTime(value) : "--";
    },
  },
  { key: "actions", label: i18n.t("操作"), class: "text-center sticky-column" },
];
